import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * TrendingTagsRail — horizontal scroll of the hottest topic tags so fans can
 * jump straight into what everyone's reading. CSS-only scroll, no libraries.
 * Renders a fixed-height shell while loading to stay CLS-safe; collapses only
 * when the site genuinely has no tags.
 */
export const TrendingTagsRail = () => {
  const [tags, setTags] = useState(null);

  useEffect(() => {
    api.get("/tags", { params: { limit: 14 } })
      .then((r) => setTags(r.data.tags || []))
      .catch(() => setTags([]));
  }, []);

  if (Array.isArray(tags) && tags.length === 0) return null;

  return (
    <section
      className="max-w-[1400px] mx-auto px-5 md:px-8 mt-8 md:mt-12"
      data-testid="trending-tags-rail"
      aria-label="Trending topics"
    >
      <div className="flex items-center gap-3 min-h-[38px]">
        <span className="shrink-0 inline-flex items-center gap-1.5 font-cond uppercase tracking-[0.24em] text-[10px] text-titans-red font-bold">
          <Flame size={12} /> Trending
        </span>
        <div className="flex-1 min-w-0 overflow-x-auto scrollbar-none">
          <div className="flex items-center gap-2 w-max pr-4">
            {tags === null
              ? [0, 1, 2, 3, 4].map((i) => (
                  <span key={i} className="h-[30px] w-24 rounded-full bg-white/[0.05] animate-pulse" />
                ))
              : tags.map((t) => (
                  <Link
                    key={t.slug}
                    to={`/tag/${t.slug}`}
                    data-testid={`trending-tag-${t.slug}`}
                    className="shrink-0 inline-flex items-center gap-1.5 rounded-full border border-white/[0.14] bg-white/[0.04] px-3.5 py-1.5 font-cond uppercase tracking-wider text-[11px] text-white/85 hover:text-white hover:border-titans-blue hover:bg-titans-blue/15 transition-colors"
                  >
                    #{t.name}
                    <span className="text-titans-blue text-[9px]">{t.count}</span>
                  </Link>
                ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrendingTagsRail;
